<!--
 * @Author: mazhigang
 * @Date: 2023-07-01 19:16:24
 * @LastEditors: mazhigang
 * @LastEditTime: 2023-09-03 13:15:17
-->
<template>
  <div class="content">
    <system :leftList="leftList"></system>
    <div class="pageBox">
      <div class="breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>通知管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="pageTabAdd">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <el-page-header @back="goBack" :content="title"> </el-page-header>
          </div>
          <el-form
            label-position="right"
            :model="ruleForm1"
            :rules="rules"
            ref="ruleForm"
            class="demo-ruleForm"
          >
            <el-form-item label="标题" prop="name">
              <el-input
                v-model="ruleForm1.name"
                placeholder="请输入标题"
              ></el-input>
            </el-form-item>
            <el-form-item label="跳转地址" prop="url">
              <el-input
                v-model="ruleForm1.url"
                placeholder="请输入跳转地址"
              ></el-input>
            </el-form-item>
            <el-form-item label="类型" prop="type">
              <el-select
                v-model="ruleForm1.type"
                placeholder="请选择"
                style="margin-right: auto"
              >
                <el-option label="系统通知" value="0"> </el-option>
                <el-option label="任务通知" value="1"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="通道类型" prop="type1">
              <el-select
                v-model="ruleForm1.type1"
                placeholder="请选择"
                style="margin-right: auto"
              >
                <el-option label="短信通道" value="2"> </el-option>
                <el-option label="极光推送通道" value="0"> </el-option>
                <el-option label="环信IM" value="1"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="短信模板号"
              prop="templateNo"
              v-if="ruleForm1.type1 == '2'"
            >
              <el-input
                v-model="ruleForm1.templateNo"
                placeholder="请输入短信模板号"
              ></el-input>
            </el-form-item>
            <el-form-item label="发送对象" prop="send">
              <el-select
                v-model="ruleForm1.send"
                placeholder="请选择"
                style="margin-right: auto"
              >
                <el-option label="全体" value="0"> </el-option>
                <el-option label="客户" value="1"> </el-option>
                <el-option label="所有保安" value="2"> </el-option>
                <el-option label="临勤" value="3"> </el-option>
                <!-- <el-option label="保安公司" value="4"> </el-option>
                <el-option label="保安公司员工" value="5"> </el-option> -->
              </el-select>
            </el-form-item>
            <el-form-item label="发送机型" prop="send">
              <el-select
                v-model="ruleForm1.systemType"
                placeholder="请选择"
                style="margin-right: auto"
              >
                <el-option label="所有" value="0"> </el-option>
                <el-option label="IOS" value="1"> </el-option>
                <el-option label="Android" value="2"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="版本要求" prop="">
              <el-select
                v-model="ruleForm1.versionCondition"
                placeholder="请选择"
                style="margin-right: auto"
              >
                <el-option label="无" value="0"> </el-option>
                <el-option label="<" value="1"> </el-option>
                <el-option label="<=" value="2"> </el-option>
                <el-option label="=" value="3"> </el-option>
                <el-option label=">" value="4"> </el-option>
                <el-option label=">=" value="5"> </el-option>
              </el-select>
              <el-input
                style="margin-left: 10px"
                v-model="ruleForm1.versionNo"
                placeholder="请输入版本号"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="是否循环"
              prop="select"
              style="display: flex; align-items: center"
            >
              <el-radio-group v-model="ruleForm1.select">
                <el-radio label="1">是</el-radio>
                <el-radio label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="发送时间" prop="time">
              <el-date-picker
                v-model="ruleForm1.time"
                type="datetime"
                placeholder="选择日期时间"
                @change="selectTime"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="上传图片" prop="img">
              <el-upload
                style="margin-right: auto"
                list-type="picture-card"
                class="avatar-uploader"
                :action="uploadUrl"
                :headers="deader"
                :on-success="handleAvatarSuccess"
                :multiple="true"
                :file-list="ruleForm1.img"
                :limit="5"
              >
                <i class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
            <el-form-item label="通知内容" prop="memo">
              <el-input
                type="textarea"
                v-model="ruleForm1.memo"
                placeholder="请输入通知内容"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button @click="resetForm1('ruleForm')">取消</el-button>
              <el-button
                type="primary"
                @click="submitForm('ruleForm')"
                style="margin-right: auto"
                >确定</el-button
              >
            </el-form-item>
          </el-form>
        </el-card>
      </div>
    </div>
  </div>
</template>
<script>
import system from "../../components/system_left.vue";
import axiosUrl from "../../api/axios.js";
export default {
  components: {
    system,
  },
  data() {
    return {
      leftList: this.Plugins.operateData(),
      title: "新增通知",
      ruleForm1: {
        name: "",
        url: "",
        type: "",
        type1: "",
        send: "",
        select: "",
        memo: "",
        time: "",
        templateNo: "",
        systemType: "",
        versionNo: "",
        versionCondition: "",
        img: [],
      },
      rules: {
        type: [{ required: true, message: "必选项", trigger: "change" }],
        type1: [{ required: true, message: "必选项", trigger: "change" }],
        send: [{ required: true, message: "必选项", trigger: "change" }],
        // time: [{ required: true, message: "必选项", trigger: "change" }],
        select: [{ required: true, message: "必选项", trigger: "change" }],
        systemType: [{ required: true, message: "必选项", trigger: "change" }],
        // img: [{ required: true, message: "必选项", trigger: "change" }],
        memo: [{ required: true, message: "必填项", trigger: "blur" }],
        name: [{ required: true, message: "必填项", trigger: "blur" }],
        // url: [{ required: true, message: "必填项", trigger: "blur" }]
      },
      options: [{ name: "", id: "" }],
      editId: "",
      deader: {
        "x-ba-admin-token": localStorage.getItem("TOKEN"),
      },
      uploadUrl: "",
    };
  },
  created: function () {
    this.uploadUrl = axiosUrl.defaults.baseURL + "admapi/sys/file/upload";
    if (this.$route.query.id) {
      this.editId = this.$route.query.id;
      this.title = "编辑通知";
      this.getDetail();
    }
  },
  methods: {
    selectTime(val) {
      // 中国标准时间
      let date1 = val;
      // 年
      let y = date1.getFullYear();
      // 月
      let m = date1.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      // 日
      let d = date1.getDate();
      d = d < 10 ? "0" + d : d;
      // 时
      let h = date1.getHours();
      h = h < 10 ? "0" + h : h;
      // 分
      let M = date1.getMinutes();
      M = M < 10 ? "0" + M : M;
      // 秒
      let s = date1.getSeconds();
      s = s < 10 ? "0" + s : s;
      this.ruleForm1.time = y + "-" + m + "-" + d + "T" + h + ":" + M + ":" + s;
    },
    goBack() {
      this.$router.go(-1);
    },
    handleAvatarSuccess(res, file) {
      let obj = {};
      obj.url = res.data;
      this.ruleForm1.img.push(obj);
    },
    resetForm1(formName) {
      this.$refs[formName].resetFields();
      this.$router.go(-1);
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let list = this.ruleForm1.img;
          let arr = [];
          for (var i = 0; i < list.length; i++) {
            arr.push(list[i].url);
          }
          if (
            (this.ruleForm1.versionNo != "" &&
              this.ruleForm1.versionCondition == "") ||
            (this.ruleForm1.versionNo == "" &&
              this.ruleForm1.versionCondition != "")
          ) {
            this.$message({
              message: "版本要求和版本号必须同步",
              type: "warning",
            });
            return;
          }
          let param = {
            title: this.ruleForm1.name,
            url: this.ruleForm1.url,
            broadcastType: this.ruleForm1.type,
            memo: this.ruleForm1.memo,
            memberType: this.ruleForm1.send,
            systemType: this.ruleForm1.systemType,
            crontab: this.ruleForm1.select,
            sendAt: this.ruleForm1.time,
            imageUrlList: arr,
            channelType: this.ruleForm1.type1,
            versionNo: this.ruleForm1.versionNo,
            versionCondition: this.ruleForm1.versionCondition,
          };
          if (this.editId == "") {
            this.$axios
              .post(`/admapi/broadcast/add`, param)
              .then(({ data }) => {
                this.$message({
                  message: "添加成功",
                  type: "success",
                });
                this.goBack();
              })
              .catch()
              .finally((this.dialogFormVisible = false));
          } else {
            param.id = this.editId;
            this.$axios
              .post(`/admapi/broadcast/update`, param)
              .then(({ data }) => {
                this.$message({
                  message: "编辑成功",
                  type: "success",
                });
                this.goBack();
              })
              .catch()
              .finally(() => {
                this.dialogFormVisible = false;
                this.editId = "";
                this.ruleForm1.name = "";
                this.ruleForm1.url = "";
                this.ruleForm1.type = "";
                this.ruleForm1.type1 = "";
                this.ruleForm1.systemType = "";
                this.ruleForm1.send = "";
                this.ruleForm1.select = "";
                this.ruleForm1.memo = "";
                this.ruleForm1.time = "";
                this.ruleForm1.img = "";
                (this.ruleForm1.versionNo = ""),
                  (this.ruleForm1.versionCondition = "");
              });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    getDetail() {
      this.$axios
        .post(`/admapi/broadcast/get/${this.editId}`)
        .then(({ data }) => {
          this.detail = data;
          this.ruleForm1.name = data.title;
          this.ruleForm1.url = data.url;
          this.ruleForm1.type = JSON.stringify(data.broadcastType);
          this.ruleForm1.type1 = JSON.stringify(data.channelType);
          this.ruleForm1.send = JSON.stringify(data.memberType);
          this.ruleForm1.select = JSON.stringify(data.crontab);
          this.ruleForm1.memo = data.memo;
          this.ruleForm1.templateNo = data.templateNo;
          this.ruleForm1.systemType = JSON.stringify(data.systemType);
          this.ruleForm1.time = data.sendAt.replace(" ", "T");
          this.ruleForm1.versionNo = data.versionNo;
          this.ruleForm1.versionCondition = JSON.stringify(
            data.versionCondition
          );
          let arr =
            data.images && data.images != "" ? data.images.split(",") : "";
          for (var i = 0; i < arr.length; i++) {
            this.ruleForm1.img.push({
              url: arr[i],
            });
          }
        })
        .catch()
        .finally();
    },
  },
};
</script>
<style scoped>
.demo-ruleForm {
  width: 650px;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 148px;
  height: 148px;
  margin: 0 auto;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
